var IMPORTED = "ConfigurationPackageImported";
var FIELDS = [
    "action",
    "external_id",
    "revision",
    "manifest_sha256",
    "content_hash",
    "design_digests",
];
var isObject = function (value) {
    return !!value && typeof value === "object" && !Array.isArray(value);
};
/** Keep hashes in the details while leaving historical signed descriptions intact. */
export var configurationPackageDescription = function (t, kind, message) {
    var _a, _b;
    if (kind !== IMPORTED)
        return null;
    var body = (_a = message === null || message === void 0 ? void 0 : message.statement) === null || _a === void 0 ? void 0 : _a.body;
    if (!isObject(body))
        return null;
    var imported = (_b = body.ConfigurationPackageWithContentHash) !== null && _b !== void 0 ? _b : body.ConfigurationPackage;
    if (!Array.isArray(imported) || !isObject(imported[1]))
        return null;
    var details = imported[1];
    if (typeof details.external_id !== "string" || typeof details.revision !== "number")
        return null;
    return String(t("logsScreen.configurationPackage.imported", {
        externalId: details.external_id,
        revision: details.revision,
    }));
};
export var configurationPackageFieldLabel = function (t, kind, name) {
    return kind === IMPORTED && FIELDS.includes(name)
        ? String(t("logsScreen.configurationPackage.fields.".concat(name)))
        : name;
};
